<template>
    <div class="padding-left-20">
        <div v-html="category"></div>
    </div>
</template>

<script>
    export default {
        props:['category'],
        data(){
            return {

            }
        },
        created(){
            this.category = this.category.replace(/\n/g,'<br>')
        }
    }
</script>
